import request from '@/src/utils/request'

//住宿價格計算
export const postHotelOrderCalculate = async (productId, payload) => {
  const response = await request.post(`/admin/hotel/${productId}/order/calculate`, payload)
  return response
}

//取得住宿訂單明細
export const getOrder = async (productId, containerId) => {
  console.log('getOrderAPI', productId, containerId)
  const response = await request.get(`/admin/hotel/${productId}/order/${containerId}`)
  return response
}

//取得住宿訂單表單（包含寵物資訊和住宿單題目）
export const getOrderForm = async (productId, containerId, orderId) => {
  const response = await request.get(`/admin/hotel/${productId}/order/${containerId}/${orderId}/form`)
  return response
}

//建立或更新住宿訂單表單
export const postHotelOrderForm = async (productId, containerId, orderId, payload) => {
  const response = await request.post(`/admin/hotel/${productId}/order/${containerId}/${orderId}/form`, payload)
  return response
}

//取得寵物簡易清單 (建立住宿步驟二使用)
export const getMemberPets = async (memberId) => {
  const response = await request.get(`/admin/merchant/member/${memberId}/pets`)
  return response
}

//建立住宿新訂單(第一張)
export const postHotelOrder = async (productId, payload) => {
  const response = await request.post(`/admin/hotel/${productId}/order`, payload)
  return response
}

//更新住宿訂單 狀態、備註
export const patchHotelOrder = async (productId, containerId, orderId, payload) => {
  const response = await request.patch(`/admin/hotel/${productId}/order/${containerId}/${orderId}`, payload)
  return response
}

//更新住宿訂單 狀態、備註 (新版！)
export const postHotelOrderAction = async (productId, containerId, orderId, payload) => {
  const response = await request.post(`/admin/hotel/${productId}/order/${containerId}/${orderId}/action`, payload)
  return response
}

//住宿訂單退款
export const postHotelOrderRefund = async (productId, containerId, orderId, payload) => {
  const response = await request.post(`/v2/admin/hotel/${productId}/order/${containerId}/${orderId}/refund`, payload, {
    errorHandle: false,
  })
  return response
}

// 住宿訂單改期
export const postHotelOrderReschedule = async (productId, containerId, orderId, payload) => {
  const response = await request.post(
    `/v2/admin/hotel/${productId}/order/${containerId}/${orderId}/reschedule`,
    payload,
    { errorHandle: false },
  )
  return response
}
